import React from 'react';
import Form from './form';
import Map from './map';
import './index.css';

class Booking extends React.Component {
    state = {
        lat: null,
        lng: null
    }

    handlerChangeAdress = (lat, lng) => {
        this.setState({lat: lat, lng: lng});
    }

    render(){
        return (
          <section className="booking" id="booking">
              <div className="booking__form">
                  <Form onAddressChange={this.handlerChangeAdress} enterLat={this.state.lat} enterLng={this.state.lng} carColor={this.props.selectedColor}/>
              </div>
              <div className="booking__map">
                  <h4 className="map__title">Pickup location</h4>
                  <div className="map__wrapper">
                      <Map enterLat={this.state.lat} enterLng={this.state.lng}/>
                  </div>
                  <h5 className="map__text">
                      “You’re in <br/> for the ride <br/> of your life.” 
                  </h5>
                  <h6 className="map__autor">- Jason Vestri</h6>
              </div>
          </section>
        );
    }
}

export default Booking;
